import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response2 } from 'src/app/utils/interfaces/reponse';
import { Usuario } from 'src/app/utils/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {

  headers = new HttpHeaders().set('Content-Type', 'application/json')

  usuario: Usuario = new Usuario();

  constructor(private readonly http: HttpClient) {}

  getUserByAlias(alias: string): Observable<Response2<Usuario>> {
    
    return this.http.get<Response2<Usuario>>(environment.dashboard + `usuarios/alias/${alias}`);

  }

  
  getUserByAliasV2(alias: string): Observable<Response2<Usuario>> {
  
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    return this.http.get<Response2<Usuario>>(environment.apis_goadmin.concat(`api/v1/usuarios/alias/${alias}`));
  }

  getUserById(idUsuario: number): Observable<any> {
    return this.http.get(environment.dashboard + `usuarios/${idUsuario}`);
  }

  // setUser(usuario: Usuario): void {
  //   this.usuario = usuario;
  // }
  // getUser(): Usuario {
  //   return this.usuario;
  // }
}
